(ns mold-forms.model
  (:require [mold.core :as m :refer-macros [defmodel]]))


(m/defmodel form-field
  {:name  [::m/keyword ::m/req ::m/identity "Field name"]
   :value ["Field value"]})


(m/defmodel form-error
  {:field-id [::m/keyword "Field name"]
   :form-id  [::m/keyword "Form id"]
   :id       [::m/keyword ::m/req ::m/identity "Form error id"]
   :value    [::m/string ::m/req "Error message"]
   :meta     ["Error meta"]})


(m/defmodel form-model
  {:id            [::m/keyword ::m/req ::m/identity "Unique ID"]
   :changed       [::m/bool ::m/nilable "Is form changed"]
   :track-changes [::m/bool "Should the form to keep the eye on changes"]
   :fields        {::m/type         ::m/ref
                   ::m/ref-type     form-field
                   ::m/is-component ::m/component
                   ::m/cardinality  ::m/many
                   ::m/doc          "Form fields"}
   :errors        {::m/type         ::m/ref
                   ::m/ref-type     form-error
                   ::m/is-component ::m/component
                   ::m/cardinality  ::m/many
                   ::m/doc          "Form field errors"}})
